import axios from './requestClient';

export const fetchJobTitles = (language) => {
  return axios.get(`/api/v1/ServerMetaData/JobTitles`, { language });
};

export const fetchCountries = (language) => {
  return axios.get(`/api/v1/ServerMetaData/Countries`, { language });
};
export const fetchLanguages = (language) => {
  return axios.get(`/api/v1/ServerMetaData/Languages`, { language });
};
